import React, { useState, useEffect } from 'react'

import { Button, Icon, ArrowRight } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import useApiPut from 'Pods/Shared/Hooks/useApiPut'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import useSentry from 'Pods/Shared/Hooks/useSentry'

function ProceedToCheckoutButton({ disabled = false, label = 'Proceed to checkout' }) {
  const [shouldOpenCart, setShouldOpenCart] = useState(false)
  const [hasClicked, setHasClicked] = useState(false)

  const pageConfig = usePageConfig()

  useEffect(() => {
    const { cart } = pageConfig || {}
    const { totalPrice, saleThreshold } = cart || {}

    if (totalPrice && saleThreshold && totalPrice < saleThreshold) {
      setShouldOpenCart(true)
    }
  }, [pageConfig])

  const { captureException } = useSentry()

  const {
    putData,
    isLoading: isPutDataLoading,
  } = useApiPut()

  const handleProceedToCheckoutClick = (event) => {
    event.preventDefault()

    if (shouldOpenCart && !hasClicked) {
      setHasClicked(true)
      App.events.publish('top:menu:cart:open')

      return
    }

    putData({
      path: "/checkout/track-product-page-proceed-to-checkout-click",
      onSuccess: () => {
        window.location.href = '/cg/checkout/payment'
      },
      onError: (error) => {
        window.showNotification('Failed to proceed to checkout', {
          type: 'error',
          autohide: true,
        })
        captureException(error)
      },
    })
  }

  return (
    <Button
      type="primary-warning"
      customClass="pricing-area__actions-button pricing-area__actions-right-button"
      size="large"
      onClick={handleProceedToCheckoutClick}
      trailIcon={<Icon svgComponent={ArrowRight} />}
      disabled={disabled || isPutDataLoading}
      aria-label={label}
    >
      {label}
    </Button>
  )
}

ProceedToCheckoutButton.propTypes = {
  disabled: bool,
  label: string,
}

export default ProceedToCheckoutButton
